import { getResponsiveTypography, mq } from '@phishtool/ui';
import styled from 'styled-components';
export const StyledUtilityPageWrapper = styled.div.withConfig({ displayName: "StyledUtilityPageWrapper", componentId: "sc-1stwjbx" }) `
  margin-bottom: ${(props) => props.theme.spacers.x6};
`;
export const StyledUtilityPageHeading = styled.h1.withConfig({ displayName: "StyledUtilityPageHeading", componentId: "sc-zzrq8m" }) `
  text-align: ${(props) => { var _a; return (_a = props.align) !== null && _a !== void 0 ? _a : 'left'; }};
  margin-bottom: ${(props) => props.theme.spacers.x3};
  ${(props) => getResponsiveTypography(props.theme.typography, ['x7', 'x9'])}

  ${(props) => mq({
    marginTop: [props.theme.spacers.x3, props.theme.spacers.x12],
})}
`;
